import { Component, OnInit, HostListener, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'ccp-form-title',
  templateUrl: './form-title.component.html',
  styleUrls: ['./form-title.component.scss']
})
export class FormTitleComponent implements OnInit {
  @Input() public formTitle: string;
  @ViewChild('formTitleArea', { static: true }) public formTitleArea: ElementRef;

  element: any;
  sticky: any;
  sidebar: Element;
  isSticky: boolean = false;
  readonly stickyClassName: string = 'sticky';

  constructor() { }

  ngOnInit() {
    this.element = this.formTitleArea.nativeElement;
    this.sticky = this.element.offsetTop;
  }

  ngAfterViewInit() {
    this.sidebar = document.querySelector('.side-nav-bar');
  }

  updateStickyOffset() {
    let offsetTop = this.element.offsetTop;
    if (offsetTop > this.sticky) {
      this.sticky = offsetTop;
    }
  }

  toggleStickyElement() {
    this.element.classList.toggle(this.stickyClassName);
    if (this.sidebar) {
      this.sidebar.classList.toggle(this.stickyClassName);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.updateStickyOffset();
    if ((window.pageYOffset > this.sticky) !== this.isSticky) {
      this.isSticky = window.pageYOffset > this.sticky;
      this.toggleStickyElement();
    }
  }

}
